import { useTranslation } from "react-i18next";
import { RiMoneyDollarCircleLine } from "react-icons/ri";

import HeadlessDialog from "@components/Dialog";
import { PayRateFields } from "./PayRateFields";
import { BillRateFields } from "./BillRateFields";
import ScrollableModalBody from "@components/ScrollableModalBody";
interface IRatesEditProps {
  worker_id: number;
  contractor_name: string;
  isOpen: boolean;
  onClose: () => void;
}

export function RatesEdit({
  worker_id,
  contractor_name,
  isOpen,
  onClose,
}: IRatesEditProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      {isOpen && (
        <HeadlessDialog
          title={
            <div className="tw-flex tw-items-center tw-gap-2">
              <RiMoneyDollarCircleLine
                className="tw-text-primary-light"
                size={24}
              />
              <span>{t("Rate.title")}</span>
            </div>
          }
          description=""
          isOpen={isOpen}
          setIsOpen={onClose}
          onClose={onClose}
          buttonText="Close"
          size="tw-w-[100vw] md:tw-max-w-[40vw]"
        >
          <div className="tw-text-lg tw-font-bold tw-text-primary-light">
            {contractor_name}
          </div>
          <ScrollableModalBody>
            <PayRateFields worker_id={worker_id} />
            <BillRateFields worker_id={worker_id} />
          </ScrollableModalBody>
        </HeadlessDialog>
      )}
    </>
  );
}
